import { Typography } from '@mui/material';
import { Link } from 'react-scroll';
// import fonts from '../images/fonts.png';
import './Main.css';
import Grid from '@mui/material/Grid';
import newFemale from '../images/newFemale.jpg'
import { Container} from '@mui/material';

const Main = () => {
    return (

        <Container maxWidth="xl" sx={{ backgroundColor: "#ffffff", paddingY: 10, textAlign: "center", width: "100%", }}>
            <div id="hiw" className="howitworks"><Typography variant="h4">Government Pleader / Public Prosecutor

</Typography></div>

        <Grid container spacing={2} alignItems="center" justifyContent="center" sx={{ padding: "0px 7rem" }}>

            <Grid item xs={12} sm={6}>
                <div className="text-container"
                >
                    <Typography variant="h5" sx={{
                        padding: "10px", fontSize: "28px",
                        fontWeight: "600"
                    }}>Mrs MANISHA LAVKUMAR SHAH</Typography>
                    <Typography variant="body1" sx={{ padding: "10px", textAlign: "justify" }}>
                        Government Pleader - GP
                        Senior Advocate And Government Pleader, High Court Of Gujarat
                        Mrs Lavkumar was designated by the High Court of Gujarat as a Senior Advocate. After a long lapse of 26 years.
                        She is only the second woman to be designated by the High Court of Gujarat as a Senior Advocate.
                    </Typography>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <img
                    src={newFemale}
                    alt="Your Image"
                    style={{ width: '100%', height: '100%', justifyItems: 'left', alignItems: 'left', display: 'flex', margin: '0 auto' }}
                />
            </Grid>


        </Grid>

</Container>


    )
}

export default Main;
